import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook\">\n<path d=\"M15.9999 3.33325C12.6405 3.33325 9.41869 4.66777 7.04323 7.04323C4.66777 9.41869 3.33325 12.6405 3.33325 15.9999C3.33325 19.3593 4.66777 22.5811 7.04323 24.9566C9.41869 27.3321 12.6405 28.6666 15.9999 28.6666C19.3593 28.6666 22.5811 27.3321 24.9566 24.9566C27.3321 22.5811 28.6666 19.3593 28.6666 15.9999C28.6666 12.6405 27.3321 9.41869 24.9566 7.04323C22.5811 4.66777 19.3593 3.33325 15.9999 3.33325Z\" fill=\"#26A69A\" />\n<path d=\"M17.7148 19.3573H20.9928L21.5074 16.0273H17.7141V14.2073C17.7141 12.8239 18.1661 11.5973 19.4601 11.5973H21.5394V8.69127C21.1741 8.64194 20.4014 8.53394 18.9414 8.53394C15.8928 8.53394 14.1054 10.1439 14.1054 13.8119V16.0273H10.9714V19.3573H14.1054V28.5099C14.7261 28.6033 15.3548 28.6666 16.0001 28.6666C16.5834 28.6666 17.1528 28.6133 17.7148 28.5373V19.3573Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/facebook.svg
// module id = ywNk
// module chunks = 13